export const SEARCH_HISTORY = 'SEARCH_HISTORY_'

export const MAX_SEARCH_QUERIES_STORED = 5
